import { Stack, styled } from "@mui/material";

export const TitleTypography = styled(Stack)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "1rem",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "1.3125rem",
  padding: "0rem 1rem"
}));
